export interface ReasonCheck {
  check_id: string
  result: string
  required?: boolean
}
/** Every failed and required inconclusive check needs its own reason. */
export function missingOverrideReasons(
  checks: ReasonCheck[],
  reasons: Record<string, string>
): string[] {
  return checks
    .filter(
      (check) =>
        (check.result === 'fail' || (check.required && check.result === 'unknown')) &&
        !reasons[check.check_id]?.trim()
    )
    .map((check) => check.check_id)
}
